window.Theme = {}
;(function () {
  window.onpageshow = function (event) {
    if (event.persisted) {
      window.location.reload()
    }
  }
})()

window.Theme.Cart = {
  init: function () {
    if (!document.querySelector(".cart")) return

    document
      .querySelector(".header-cart")
      .addEventListener("click", (event) => {
        event.preventDefault()
        document.querySelector(".cart").classList.add("cart--open")
        document.querySelector("main").classList.add("main--dark")
        document.querySelector("header").classList.add("header--dark")
      })

    document.body.addEventListener("click", (event) => {
      let path = event.path || (event.composedPath && event.composedPath())
      if (document.querySelector(".cart--open") != undefined) {
        if (
          !path.includes(document.querySelector(".cart")) &&
          !path.includes(document.querySelector(".header-cart"))
        ) {
          event.preventDefault()
          this.close()
        }
      }
    })

    window.Theme.Cart.reload()
  },
  open: function () {
    document.querySelector(".cart").classList.add("cart--open")
    document.querySelector("main").classList.add("main--dark")
    document.querySelector("header").classList.add("header--dark")
  },
  close: function () {
    document.querySelector(".cart").classList.remove("cart--open")
    document.querySelector("main").classList.remove("main--dark")
    document.querySelector("header").classList.remove("header--dark")
  },
  add: function (variantId, quantity) {
    return new Promise((resolve, reject) => {
      ShopifyAPI.Cart.add(variantId, quantity).then((response) => {
        resolve()
        if (document.querySelector(".header-cart")) {
          fetch("/cart.js", {
            methd: "GET",
          })
            .then((cartResponse) => cartResponse.json())
            .then((cartData) => {
              document.querySelector(".header-cart").dataset.empty =
                cartData.item_count == 0
              Theme.Cart.update().then(() => {
                //Theme.Cart.open();
              })
            })
        }
      })
    })
  },
  reload: function () {
    if (document.querySelector(".cart-submit-checkout")) {
      document
        .querySelector(".cart-submit-checkout")
        .addEventListener("click", () => {
          const upsellSwitch = document.querySelector(
            '.cart-upsell-switch input[type="checkbox"]'
          )
          if (upsellSwitch && upsellSwitch.checked == true) {
            ShopifyAPI.Cart.add("44563576619311", 1).then(() => {
              window.location.href = "/checkout"
            })
          } else {
            window.location.href = "/checkout"
          }
        })
    }

    document.querySelector(".cart-close").addEventListener("click", () => {
      Theme.Cart.close()
    })

    document
      .querySelectorAll(".cart-products .cart-item")
      .forEach((cartItem, index, array) => {
        /*cartItem.querySelector('.cart-item-remove').addEventListener('click', function (event) {
                event.preventDefault();

                ShopifyAPI.Cart.update(parseInt(cartItem.dataset.itemId), 0).then((response) => {
                    Theme.Cart.update();
                });
            });*/

        if (cartItem.classList.contains("cart-item-upsell")) return

        cartItem
          .querySelector(".cart-item-quantity-increase")
          .addEventListener("click", function (event) {
            event.preventDefault()

            let quantityInputValue =
              this.parentElement.querySelector("input").value

            ShopifyAPI.Cart.update(
              parseInt(cartItem.dataset.itemId),
              parseInt(quantityInputValue) + 1
            ).then((response) => {
              document.querySelector(".header-cart").dataset.empty =
                response.item_count == 0
              Theme.Cart.update()
            })
          })

        // Quantity Decrease Listener
        cartItem
          .querySelector(".cart-item-quantity-decrease")
          .addEventListener("click", function (event) {
            event.preventDefault()

            let quantityInputValue =
              this.parentElement.querySelector("input").value

            ShopifyAPI.Cart.update(
              parseInt(cartItem.dataset.itemId),
              parseInt(quantityInputValue) - 1
            ).then((response) => {
              document.querySelector(".header-cart").dataset.empty =
                response.item_count == 0
              Theme.Cart.update()
            })
          })

        const variantWorth = document.querySelectorAll(
          ".cart-item-meta-variant-worth"
        )
        variantWorth.forEach((variantWorth) => {
          if (variantWorth) {
            switch (Shopify.currency.active) {
              case "USD":
                variantWorth.innerHTML = "WORTH $24.95"
                break
              case "CAD":
                variantWorth.innerHTML = "WORTH $34.95"
                break
              case "AUD":
                variantWorth.innerHTML = "WORTH $39.95"
                break
              case "GBP":
                variantWorth.innerHTML = "WORTH £19.95"
                break
              case "EUR":
                variantWorth.innerHTML = "WORTH 24.95€"
                break
              case "NZD":
                variantWorth.innerHTML = "WORTH $34.95"
                break
            }
          }
        })
      })

    Theme.Cart.upsell()
  },
  update: function () {
    return new Promise((resolve, reject) => {
      fetch("/?sections=cart-sidebar", {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
          let newSidebar = document.createElement("html")
          newSidebar.innerHTML = `<body>${data["cart-sidebar"]}</body>`
          newSidebar = newSidebar.querySelector("#shopify-section-cart-sidebar")

          let totalQuantity = 0
          newSidebar
            .querySelectorAll(".cart-item input")
            ?.forEach(
              (element, index, array) =>
                (totalQuantity += parseInt(element.value))
            )

          document.querySelector(".cart-header").innerHTML =
            newSidebar.querySelector(".cart-header").innerHTML
          document.querySelector(".cart-products").innerHTML =
            newSidebar.querySelector(".cart-products").innerHTML
          document.querySelector(".cart-upsell").innerHTML =
            newSidebar.querySelector(".cart-upsell").innerHTML
          document.querySelector(".cart-checkout").innerHTML =
            newSidebar.querySelector(".cart-checkout").innerHTML

          Theme.Cart.reload()
          resolve()
        })
    })
  },
  upsell: function () {
    if (!document.querySelector(".cart-item-upsell")) return

    const product = JSON.parse(
      document.querySelector(".cart-item-upsell .product-upsell-data").innerHTML
    )
    const currentVariant = product.variants[product.variants.length - 1]

    const upsellSwitch = document.querySelector('.cart-upsell-switch input[type="checkbox"]')
    function handleSwitch() {
      const subtotal = document.querySelector('.cart-total');
        ShopifyAPI.Cart.get().then(cartData => {
          if (upsellSwitch.checked) {
              subtotal.textContent = 'Subtotal: ' + Shopify.formatMoney(cartData.items_subtotal_price + currentVariant.price);
          } else {
            subtotal.textContent = 'Subtotal: ' + Shopify.formatMoney(cartData.items_subtotal_price);
          }
        })
    }
    handleSwitch()
    upsellSwitch.addEventListener("change", () => {
        handleSwitch()
    });
    

    document.querySelector(".cart-item-upsell-price").textContent =
      Shopify.formatMoney(currentVariant.price) + " x 1"

    /*Theme.Cart.add('44563576619311', 1).then(() => {
    })*/
  },
}

document.addEventListener("DOMContentLoaded", () => {
  window.Theme.Cart.init()
})
